import { memo } from 'react';
import cn from 'classnames';
import { type TestProps, Text } from '@direct-frontend/components';
import { useToggle } from '@direct-frontend/stdlib';
import { InfoBlock } from '#shared/ui/InfoBlock';
import helpingHand from './assets/helping-hand.svg';
import styles from './ProductMediaOrderInfoBlock.module.css';

export type ProductMediaOrderInfoBlockProps = {
    className?: string;
} & TestProps;

export const ProductMediaOrderInfoBlock = memo(function ProductMediaOrderInfoBlock({
    className,
    'data-testid': dataTestId = 'ProductMediaOrderInfoBlock',
}: ProductMediaOrderInfoBlockProps) {
    const { value: isInfoBlockModalOpen, toggleOff: closeInfoBlockModal } = useToggle(true);

    if (!isInfoBlockModalOpen) {
        return null;
    }

    return (
        <InfoBlock
            className={cn(styles.root, className)}
            color="message"
            onClose={closeInfoBlockModal}
            type="illustration"
            imageAlt="Вспомогательное изображение"
            imageSrc={helpingHand}
            data-testid={dataTestId}
        >
            <Text className={styles.text} size="m" data-testid={`${dataTestId}.Text`}>
                Перетаскивайте карточки, чтобы настроить порядок
            </Text>
        </InfoBlock>
    );
});
